module.exports = __webpack_public_path__ + "img/ct.6ddfb55e.png";